import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { HostService } from 'src/app/services/host.service';
import { AppService } from 'src/app/app.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { RentingService } from 'src/app/services/renting.service';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { RentingMessageComponent } from 'src/app/shared/renting-message/renting-message.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShowFileConstatComponent } from 'src/app/compte-utilisateur/addconstat/addconstat.component';

@Component({
  selector: 'app-showcar',
  templateUrl: './showcar.component.html',
  styleUrls: ['./showcar.component.scss']
})
export class ShowcarComponent implements OnInit {
  //Subscription
  VehiculeSubscription: Subscription;
  changeStatusSubscription: Subscription;
  statusChanged: boolean;
  rentingGetted: boolean;
  public userIn: any;
  imageVehicule :Array<object>=[];
  vehiculeId: any;
  public config: SwiperConfigInterface = { };
  public chefs:any[] = [];
  displayedColumns: string[] = ['dateStart', 'dateEnd', 'price', 'status', 'date', 'lodger', 'actions'];
  rentings: any;
  vehicule:any;
  dataSource!: MatTableDataSource<any>;


  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
            private vehiculeService: VehiculeserviceService, 
            public router: Router,
            private activetedRoute: ActivatedRoute,
            private hostService : HostService,
            public appService:AppService,
            private rentingService: RentingService,
            private toastr: ToastrService,
            private spinner: NgxSpinnerService,
            public dialog: MatDialog
            ) { }

  ngOnInit(): void {
    this.loadData();
   // this.chefs = this.appService.getChefs();
    const storageAuth = localStorage.getItem("user");
    if (storageAuth) {
      this.userIn = JSON.parse(storageAuth);
    }
  }

  loadData()
  {
    this.vehiculeId = this.activetedRoute.snapshot.queryParamMap.get("vehicule");
     this.VehiculeSubscription=this.vehiculeService.showOneCar(this.vehiculeId).subscribe((res:any)=>{
        console.log(res);
        let images:Array<any> = res.data.image;
        images.forEach(elt=>{
          let objectDefine = {
            image: this.hostService.getHttpsImage()+elt.title_image,
            thumbImage:this.hostService.getHttpsImage()+elt.title_image,
            alt: 'alt of image'
          };  

          this.imageVehicule.push(objectDefine);
        });

        this.rentingGetted = false;
        this.vehicule= res.data;
        this.rentings = res.data.reservation;
        this.dataSource = new MatTableDataSource(res.data.reservation);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        
      },error=>{
        this.toastr.show("Une erreur s'est produite veillez contacter votre administrateur","Erreur Erreur",
          {
            timeOut: 5000,
            closeButton: true,
          } as IndividualConfig,
          "toast-" + "error"
        );
        console.log(error);
      })
      this.statusChanged = false;
  }

  public changeStatus(idRenting: number, value: string) {
    let currentObject = this.rentings.find(
      (renting: any) => renting.id == idRenting
    );

    if (currentObject.renting_status != value) {
      let obj = {
        id: idRenting,
        status: value,
      };

      this.spinner.show();

      this.changeStatusSubscription = this.rentingService
        .changeStatus(obj)
        .subscribe((response: any) => {

          this.loadData();

          this.spinner.hide();
          
          this.toastr.show("Le status de la réservation du " + currentObject.renting_date_departure +" au " + currentObject.renting_date_return + " du véhicule a été modifié","Status Changé",
            {
              timeOut: 5000,
              closeButton: true,
            } as IndividualConfig,
            "toast-" + "success"
          );
        });
    } else {
      this.toastr.show("Impossible d'effectuer cette action","Erreur Erreur",
        {
          timeOut: 5000,
          closeButton: true,
        } as IndividualConfig,
        "toast-" + "error"
      );
    }
  }

  noterReservation(id:number)
  {
      let obj = {
        id: id,
      };

      this.spinner.show();

    this.rentingService.envoiMailCar(obj).subscribe(
      (data) => {
        console.log(data);
        this.changeStatus(id, "TERMINER");
        
        this.toastr.show("Un mail a été envoyé au client pour noter le service","mail envoyé",
          {
            timeOut: 5000,
            closeButton: true,
          } as IndividualConfig,
          "toast-" + "success"
        );
        this.spinner.hide();
      },
      (error) => {
        this.toastr.show("Le mail n'a pas été envoyé","Erreur Erreur",
          {
            timeOut: 5000,
            closeButton: true,
          } as IndividualConfig,
          "toast-" + "error"
        );
      }
    );
  }

  public viewRenting(idRenting: number) {

    let renting = this.rentings.find((res: any) => res.id == idRenting);
   
    let obj = {
      'idRenting': idRenting,
      'status': renting.renting_status,
      'message': renting.renting_message,
      'key': 'owner',
    }
    
		this.appService.openDialogGalsenMessage(RentingMessageComponent, obj, 'theme-dialog');
			 
  }

  public remove() {
    this.vehiculeService.suprimeCar(this.vehiculeId).subscribe((data) => {
      console.log(data);
       this.toastr.error("vehicule suprimé");
       this.router.navigate(["compte-utilisateur/mes-vehicules/liste-vehicule"]);
    });
  }

  public edit() {
    this.router.navigate(["compte-utilisateur/mes-vehicules/edit-vehicule"], {
      queryParams: { code: this.vehiculeId },
    });
  }
  public list() {
    this.router.navigate(["compte-utilisateur/mes-vehicules/liste-vehicule"], {
      queryParams: { code: this.vehiculeId },
    });
  }

  public updateFileImage()
  {
    const dialogRef = this.dialog.open(updateFileImageComponent, {
      width: '780px',
      height:'500px',
      data: {id: this.vehiculeId,iduser:this.userIn.id},
    });

    dialogRef.afterClosed().subscribe((result:any) => {
     
      if(result !=null)
      {
        this.imageVehicule=[];
        result.forEach((elt:{[key:string]:any})=>{
          let objectDefine = {
            image: this.hostService.getHttpsImage()+'/'+elt.title_image,
            thumbImage:this.hostService.getHttpsImage()+'/'+elt.title_image,
            alt: 'alt of image'
          };  
          this.imageVehicule.push(objectDefine);
        });
      }
      
    });
  }

  ngOnDestroy(): void {
    if (this.rentingGetted) {
      this.VehiculeSubscription.unsubscribe();
    }

    if (this.statusChanged) {
      this.changeStatusSubscription.unsubscribe();
    }
    this.dialog.closeAll();
  }

}


@Component({
  selector: 'app-update-file-image',
  templateUrl: 'update-file-image.component.html',
})
export class updateFileImageComponent implements OnInit {
  imageSrc: string;
  saveFile:Array<File|any>=[];
  saveFileBase64:Array<File|any>=[];
  constructor(
    public dialogRef: MatDialogRef<updateFileImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private vehiculeService: VehiculeserviceService, 
  ) {}


  ngOnInit() {
  }

  onSelect(event:any) {
    this.saveFile.push(...event.addedFiles)

    console.log(this.saveFile);
    setTimeout(() => {
      if(event.rejectedFiles.length >0)
      {
        this.toastr.error('Assurez vous d\'avoir Selectionner une image inférieur ou égale à la taille recommandée', 'Erreur !', {
          timeOut: 5000,
        });
      }
      this.saveFile.forEach(elt=>{
        this.convertFile(elt).subscribe((base64:string) => {
          this.saveFileBase64.push({name:elt.name,image:"data:"+elt.type+";base64,"+base64});
        });
      })
    }, 2000);
  }

  onRemove(event:any) {
    this.saveFile.splice(this.saveFile.indexOf(event), 1);
    this.saveFileBase64.splice(this.saveFile.indexOf(event), 1)
  }

  onRemoveAll(){
    this.saveFile=[];
    this.saveFileBase64=[];
  }

  seeFile(event:any)
  {
    let indexFile:any=this.saveFile.indexOf(event);
    let file:any= this.saveFile[indexFile];

    const dialogRef = this.dialog.open(ShowFileConstatComponent, {
      width: '780px',
      height:'500px',
      data: {file: file},
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  convertFile(file : File) : Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event:any) => result.next(btoa(event.target.result.toString()));
    return result;
  }

  saveAllFile()
  {
    let dataObjet:{[key:string]:any}={
      id:this.data.id,
      userid:this.data.iduser,
      fileImage:this.saveFileBase64
    }
    this.vehiculeService.updateImageOfOneCar(dataObjet).subscribe((data:any)=>{
      if(data && data.length>0)
      {
        this.dialogRef.close(data);
      }
      else{
        this.dialogRef.close();
      }
    })   
  }
}